#import "./PracticeRecordingDetails.graphql"
query MyPracticeRecordingsQuery {
  myPracticeRecordings {
    ...practiceRecordingDetails
  }
}
